<script setup>
defineEmits(['goBack']);
</script>

<template>
  <header class="relative overflow-hidden">
    <div class="bg-green-900/95">
      <div class="mx-auto px-4 py-4">
        <div class="flex items-center gap-3">
          <button
            class="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 text-white flex items-center justify-center transition-all duration-200 backdrop-blur-sm hover:scale-105 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-white/50 focus:ring-offset-2 focus:ring-offset-transparent"
            @click="$emit('goBack')"
          >
            <i class="i-lucide-arrow-left" />
          </button>
          <div>
            <h1 class="text-3xl font-bold text-white m-0">
              {{ $t('CAMPAIGN.WHATSAPP_OFFICIAL.DELIVERIES.HEADER_TITLE') }}
            </h1>
            <p class="text-green-100 dark:text-green-200 max-w-2xl m-0 text-lg">
              {{ $t('CAMPAIGN.WHATSAPP_OFFICIAL.DELIVERIES.GUIDELINE_TEXT') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
